/** The fields of a key press that tell typed text from shortcuts. */
export type TypedKey = Pick<KeyboardEvent, "key" | "metaKey" | "ctrlKey" | "altKey">;

const SPACE = " ";

/**
 * True when the key types a printable character (not a shortcut, not Space) that should seed the
 * command palette's query.
 */
export function isSearchSeedKey(e: TypedKey): boolean {
  return e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey && e.key !== SPACE;
}

export function searchShortcutLabel(applePlatform: boolean): string {
  return applePlatform ? "⌘F" : "Ctrl F";
}
